import React from 'react'

export class MessageBubbleButtons extends React.Component {
  render () {
    if (this.props.message.isFromMe) return false
    const buttons = this._parseMessageButtons()
    if (buttons.length === 0) return false
    return (
      <div className="button-options">
        {buttons}
      </div>
    )
  }

  _parseMessageButtons = () => {
    let buttons = []
    const { body } = this.props.message.source
    if (body && body.includes('{button:')) {
      const matches = body.match(/\{button:([^}]+)\}/g)
      if (matches.length > 0) {
        buttons = matches.map((item, index) => {
          let message = item.split(':').slice(1).join(':')
          message = message.substring(0, message.length - 1)
          return (
            <div
              className="button-options__button"
              key={index}
              onClick={this._sendMessage(message)}
            >{message}</div>
          )
        })
      }
    }
    return buttons
  }

  _sendMessage = message => {
    return () => {
      const { manager, channelSid } = this.props
      manager.chatClient.getChannelBySid(channelSid)
        .then(channel => {
          channel.sendMessage(message);
          document.querySelector('.Twilio-MessageList').scrollTo({
            top: 999999,
            behavior: 'smooth'
          })
        });
    }
  }
}